import { useDialog } from "@datanac/datanac-mui-toolkit";
import { IconButton, Stack, Typography } from "@mui/material";
import { TilleyCard } from "components/Cards/TilleyCard";
import { DeleteIcon, ReceiptIcon } from "components/Icons/Icons";
import { formatPrice } from "utility/formatters";

import { formatDate } from "../../utility/formatters";

export default function EquipmentRepairCard({ repair, onEdit, onDelete }) {
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  const handleDeleteOnClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this repair?",
      prompt: "Are you sure you want to delete this repair?",
      promptDetail: null,
      callback: () => {
        onDelete?.(repair);
      },
    });
  };

  const handleEditOnClick = () => {
    onEdit?.(repair);
  };

  const date = repair?.repair_date ? formatDate(repair.repair_date) : "-";
  const description = repair?.description || <>&nbsp;</>;
  const parts = repair?.parts ? formatPrice(Number(repair.parts), 0) : "-";
  const labor = repair?.labor ? formatPrice(Number(repair.labor), 0) : "-";
  const partsValue = Number(repair?.parts) || 0;
  const laborValue = Number(repair?.labor) || 0;
  const total = formatPrice(partsValue + laborValue, 0);

  return (
    <>
      <TilleyCard
        data-testid={`repair-card-${repair?.id}`}
        Avatar={ReceiptIcon}
        subtitle={description}
        onClick={handleEditOnClick}
        title="Repair"
        action={
          <>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteOnClick();
                return false;
              }}
            >
              <DeleteIcon />
            </IconButton>
          </>
        }
        customContent={
          <Stack
            direction="row"
            alignItems="center"
            justifyItems="center"
            sx={{
              flexWrap: "wrap",
              gap: { xs: 2, sm: 4 },
            }}
          >
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{date}</Typography>
              <Typography variant="overline">Date</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{parts}</Typography>
              <Typography variant="overline">Parts</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{labor}</Typography>
              <Typography variant="overline">Labor</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{total}</Typography>
              <Typography variant="overline">Total</Typography>
            </Stack>
          </Stack>
        }
      />
      {confirmDialogComponent}
    </>
  );
}
